export default __webpack_public_path__ + "static/instantChatBg3-a21eb8b64ff93074cb17992e5ddcd5ca.png";